module.exports = __webpack_public_path__ + "static/media/megaphone.b8dac784.png";